import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

const URI_PREFIX = checkIsStoryBookPath('news');
const URI_PREFIX_SETTINGS = checkIsStoryBookPath('settings');
const TRENDS_PREFIX = 'trends';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const apiRoutes = (isTrends = false) => {
  const moduleName = window.location.pathname?.split('/')?.[1];
  const isTrendModule = moduleName === 'trends' || isTrends;
  const GENERATE_URI = isTrendModule
    ? `${TRENDS_PREFIX}/${URI_PREFIX}`
    : URI_PREFIX;

  return {
    // Add Parent Source
    storeParentSource: `${URI_PREFIX}/sources/store`,
    updateParentSource: `${URI_PREFIX}/sources/update`,
    showParentSource: `${GENERATE_URI}/sources/show`,
    allCountries: `${URI_PREFIX_SETTINGS}/countries/all`,
    AssignAuthor: `${URI_PREFIX}/authors/assign-influencer`,

    //Add Source Api
    languages: `${URI_PREFIX_SETTINGS}/languages/all`,
    priorities: `${URI_PREFIX}/sources/editions/priorities`,
    sourceInformation: `${URI_PREFIX}/sources/editions/init-store`,
    grabbingInformation: `${URI_PREFIX}/sources/editions/store-grabbing-data`,
    manualGrabbingStoreSections: `${URI_PREFIX}/sources/editions/sections/store`,
    manualGrabbingPreviewSections: `${URI_PREFIX}/sources/editions/sections/preview`,
    grabNews: `${URI_PREFIX}/sources/editions/sections/group/grabb-news`,
    grabArticles: `${URI_PREFIX}/sources/editions/grabb-article`,
    dateFormats: `${URI_PREFIX}/sources/editions/date-formats`,
    deleteArticleVariant: `${URI_PREFIX}/sources/editions/article-selectors/delete`,
    grabAutomatic: `${URI_PREFIX}/sources/editions/automatic-grabbing`,
    getAllCategories: `${URI_PREFIX}/sources/editions/sections/all`,
    getActiveCategories: `${URI_PREFIX}/sources/editions/sections/active`,
    getAllCategoriesGroups: `${URI_PREFIX}/sources/editions/sections/groups`,
    sectionToCategory: `${URI_PREFIX}/sources/editions/sections/assign/categories`,
    sectionsToCategories: `${URI_PREFIX}/sources/editions/sections/assign/categories`,
    activateSource: `${URI_PREFIX}/sources/editions/activate`,
    activateSourceAutoComplete: `${GENERATE_URI}/sources/activated`,
    storeAdditionInformations: `${URI_PREFIX}/sources/editions/store-addition-informations`,
    showSource: `${URI_PREFIX}/sources/editions/show-edit`,
    storeNewsRss: `${URI_PREFIX}/sources/editions/grabb-news-rss`,
    deleteSections: `${URI_PREFIX}/sources/editions/sections/trash`,
    pauseSections: `${URI_PREFIX}/sources/editions/sections/pause`,
    restoreSection: `${URI_PREFIX}/sources/editions/sections/restore`,
    getEditSourceData: `${URI_PREFIX}/sources/editions/show-edit`,
    updateSourceData: `${URI_PREFIX}/sources/editions/update`,
    //Add Categories
    getCategoryData: `${GENERATE_URI}/categories/show`,
    addNewCategory: `${URI_PREFIX}/categories/store`,
    getArticleSourceData: `${URI_PREFIX}/sources/editions/article`,
    getArticlesSourceData: `${URI_PREFIX}/sources/editions/articles`,

    //Edit Categories
    editCategory: `${URI_PREFIX}/categories/update`,

    //categories Table
    activeCategories: `${URI_PREFIX}/categories/all-active`,
    trashedCategories: `${URI_PREFIX}/categories/all-trashed`,
    categoryAutoComplete: `${GENERATE_URI}/categories/activated`,
    languagesAutoComplete: `${URI_PREFIX_SETTINGS}/languages`,
    trashedCategoryAutoComplete: `${URI_PREFIX}/categories/trashed`,
    trashCategory: `${URI_PREFIX}/categories/trash`,
    restoreCategory: `${URI_PREFIX}/categories/restore`,
    deleteCategory: `${URI_PREFIX}/categories/delete`,
    addToParentCategory: `${URI_PREFIX}/categories/attach`,
    parentCategories: `${URI_PREFIX}/categories/parent-categories`,

    // Source Table
    sourceEditionsActive: `${URI_PREFIX}/sources/editions/all-active`,
    authorsActive: `${URI_PREFIX}/authors/all-active`,
    authorsAutoComplete: `${URI_PREFIX}/authors/activated`,
    editorsActive: `${URI_PREFIX}/editors/all-active`,
    editorsAutoComplete: `${URI_PREFIX}/editors/activated`,
    allNewsEditors: `${URI_PREFIX}/editors/all`,
    allNewsAuthors: `${URI_PREFIX}/authors/all`,

    activeSources: `${GENERATE_URI}/sources/activated`,
    allTrashSources: `${URI_PREFIX}/sources/trashed`,
    incompletedSources: `${URI_PREFIX}/sources/editions/all-pending`,
    sourceAutoComplete: `${GENERATE_URI}/sources/activated`,
    trashedSourceNewsAutoComplete: `${URI_PREFIX}/sources/all`,
    sourceEditionsAutoComplete: `${GENERATE_URI}/sources/editions/activated`,
    sourceEditionsTrashAutoComplete: `${URI_PREFIX}/sources/editions/all`,
    sourceEditionsIncompletedAutoComplete: `${URI_PREFIX}/sources/editions/pending`,
    trashedSourceEditionsAutoComplete: `${URI_PREFIX}/sources/editions/trashed`,
    trashedSourceAutoComplete: `${URI_PREFIX}/sources/trashed`,
    incompletedAutoComplete: `${URI_PREFIX}/sources/editions/pending`,
    allTrashEditionsSources: `${URI_PREFIX}/sources/editions/all-trashed`,
    trashEditionsSource: `${URI_PREFIX}/sources/editions/trash`,
    deleteEditionsSource: `${URI_PREFIX}/sources/editions/delete`,
    restoreEditionsSource: `${URI_PREFIX}/sources/editions/restore`,
    pauseEditionsStatus: `${URI_PREFIX}/sources/editions/pause`,

    trashSource: `${URI_PREFIX}/sources/trash`,
    deleteSource: `${URI_PREFIX}/sources/delete`,
    restoreSource: `${URI_PREFIX}/sources/restore`,
    pauseStatus: `${URI_PREFIX}/sources/pause`,
    activatedSources: `${GENERATE_URI}/sources/activated`,
    directionsSources: `${URI_PREFIX}/sources/directions`,
    //SOURCE DETAILS
    sourceDetails: `${GENERATE_URI}/sources/show`,
    sourceEditionsDetails: `${GENERATE_URI}/sources/editions/show`,
    newsGrabbedCount: `${URI_PREFIX}/sources/articles-count`,
    sourceEditionsCount: `${URI_PREFIX}/sources/source-editions/count`,
    totalSourceEditionsCount: `${URI_PREFIX}/sources/editions/total-sources`,
    authorsCount: `${URI_PREFIX}/sources/authors-count`,
    totalSourcesCount: `${URI_PREFIX}/sources/total-sources`,
    regrabSource: `${URI_PREFIX}/sources/editions/regrab`,
    totalArticlesGrabbed: `${URI_PREFIX}/all/articles/count`,
    totalNewsGrabbed: `${URI_PREFIX}/editors/articles/count`,
    totalAllNewsGrabbed: `${URI_PREFIX}/all/articles/count`,
    opinionArticlesGrabbed: `${URI_PREFIX}/authors/articles/count`,
    totalAuthorsGrabbed: `${URI_PREFIX}/authors/count`,
    totalEditorsGrabbed: `${URI_PREFIX}/editors/count`,
    deleteArticle: `${URI_PREFIX}/delete/un-grabbed-article`,
    regrabUnGrabbedArticle: `${URI_PREFIX}/regrab-un-grabbed-article`,
    regrabArticle: `${URI_PREFIX}/regrab-article`,
    unregrabArticleAutoComplate: `${URI_PREFIX}/un-grabbed`,
    analyzedInfluencerDetails: `${URI_PREFIX}/influencers/details/show`,
    analyzedEntitiesDetails: `${URI_PREFIX}/entities/details/show`,

    //AUTHORS TABLE
    authorAutoComplete: `${URI_PREFIX}/authors/activated`,
    authorNotInfAutoComplete: `${URI_PREFIX}/authors/activated/not-influencer`,
    editorAutoComplete: `${URI_PREFIX}/editors/activated`,
    allAuthorEditorAutoComplete: `${GENERATE_URI}/writers`,

    activeAuthors: `${URI_PREFIX}/authors/all-active`,
    mergeAuthor: `${URI_PREFIX}/authors/marge`,
    // editors table

    activeEditors: `${URI_PREFIX}/editors/all-active`,
    mergeEditors: `${URI_PREFIX}/editors/marge`,
    //AUTHOR DETAILS
    authorsDetails: `${GENERATE_URI}/authors/show`,
    editorDetails: `${GENERATE_URI}/editors/show`,
    editorsDetails: `${GENERATE_URI}/editors/show`,
    //EDIT AUTHOR
    editAuthorDetails: `${URI_PREFIX}/authors/update`,
    editEditorDetails: `${URI_PREFIX}/editors/update`,
    parentNameAutoComplete: `${URI_PREFIX}/authors/parent`,
    parentEditorsNameAutoComplete: `${URI_PREFIX}/editors/parent`,

    //TAGS TABLE
    activeTags: `${URI_PREFIX}/tags/all-active`,
    trashTags: `${URI_PREFIX}/tags/all-trashed`,
    tagsAutoComplete: `${GENERATE_URI}/tags/activated`,
    trashTag: `${URI_PREFIX}/tags/trash`,
    restoreTags: `${URI_PREFIX}/tags/restore`,
    deleteTags: `${URI_PREFIX}/tags/delete`,
    trashedTagsAutoComplete: `${URI_PREFIX}/tags/trashed`,
    linkToTag: `${URI_PREFIX}/tags/link`,
    removeLinkage: `${URI_PREFIX}/tags/un-link`,
    linkedTags: `${URI_PREFIX}/tags/linked`,
    topFrequentTags: `${URI_PREFIX}/tags/articles/count`,
    topCategories: `${URI_PREFIX}/categories/articles/count`,
    newsArticles: `${URI_PREFIX}/articles/details`,

    //DASHBOARD
    totalPosts: `${URI_PREFIX}/all/articles/count`,
    totalSources: `${URI_PREFIX}/sources/total-sources`,
    totalAuthors: `${URI_PREFIX}/authors/total-count`,
    totalEditors: `${URI_PREFIX}/editors/total-count`,
    totalCategories: `${URI_PREFIX}/categories/total-categories`,
    totalTags: `${URI_PREFIX}/tags/total-tags`,
    postPerCategories: `${URI_PREFIX}/categories/posts-count`,
    SourcesCountPerStatus: `${URI_PREFIX}/sources/editions/status`,
    TopUsedTags: `${URI_PREFIX}/tags/top-used`,
    BreakingNews: `${GENERATE_URI}/breaking`,
    topAuthors: `${URI_PREFIX}/authors/top`,
    topEditors: `${URI_PREFIX}/editors/top`,
    numberOfNewsGrabbed: `${URI_PREFIX}/grabbed-chart`,

    //NEWS TABLE
    newsAutocomplete: `${URI_PREFIX}/activated`,
    allNews: `${URI_PREFIX}/all`,
    activeOpinion: `${URI_PREFIX}/authors/all`,
    opinionAutoComplete: `${URI_PREFIX}/opinion`,
    NewsBreakingNews: `${URI_PREFIX}/breaking`,

    newsBreaking: `${GENERATE_URI}/breaking/all`,
    newsUnGrabbedArticles: `${GENERATE_URI}/un-grabbed/all`,
    newsUnnecessary: `${GENERATE_URI}/all-unnecessary`,
    newsAllTrash: `${URI_PREFIX}/all-trashed`,
    breakingAutoComplete: `${GENERATE_URI}/breaking`,
    unnecessaryAutoComplete: `${GENERATE_URI}/unnecessary`,
    trashedAutoComplete: `${URI_PREFIX}/trashed`,
    trashNews: `${URI_PREFIX}/trash`,
    unnecessaryNewsById: `${GENERATE_URI}/unnecessary`,
    deleteNews: `${URI_PREFIX}/delete`,
    restoreNews: `${GENERATE_URI}/restore`,

    //NEWS DETAILS
    newsDetails: `${GENERATE_URI}/show`,
    relatedTags: `${GENERATE_URI}/related-tags`,
    relatedPosts: `${GENERATE_URI}/related-news`,
  };
};
